import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../FormGroup';
import FormActions from '../FormActions';
import { ensureAllValid } from '../../utils';

export default function LevelForm({
  action,
  state,
  isUnique,
  isValid,
  isDisabled,
  updateValue,
  send,
  cancel,
}) {
  return (
    <form className="create" id="create-level-form">
      <FormGroup
        isUnique={isUnique}
        isValid={isValid.name}
        setFocus
        label="Name"
        name="name"
        state={state.name}
        update={updateValue}
        setRequired
      />
      <FormActions
        action={action}
        send={send}
        disableSend={isDisabled || !ensureAllValid(isValid)}
        cancel={cancel}
        type="level"
      />
    </form>
  );
}

LevelForm.propTypes = {
  action: PropTypes.string.isRequired,
  state: PropTypes.object.isRequired,
  isUnique: PropTypes.bool.isRequired,
  isValid: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  updateValue: PropTypes.func.isRequired,
  send: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};
